module.exports = __webpack_public_path__ + "static/media/bell_dark.dd899491.svg";